import { useMemo } from 'react';
import MantineTable from '../../../common/table/mantine';
import { NumberInput } from '@mantine/core';

const StockPriceTable = ({
  plants,
  handleStandardPriceChange = () => {},
  loading,
  readOnly = false,
}) => {
  const plantsColumns = [
    {
      accessorKey: 'material',
      header: 'Material',
    },
    {
      accessorKey: 'plant',
      header: 'Valuation area',
    },
    {
      accessorKey: 'standard_price',
      header: 'Standard price',
      Cell: ({ row }) => {
        const { standard_price, isEditable, plant } = row.original;

        return (
          <NumberInput
            value={standard_price ?? ''}
            step={0.01}
            min={0}
            disabled={!isEditable || readOnly}
            hideControls
            precision={2}
            onChange={(value) => handleStandardPriceChange(plant, value)}
            styles={{
              input: {
                textAlign: 'right',
                fontSize: '14px',
                backgroundColor: isEditable ? 'white' : '#f8f9fa',
                cursor: isEditable ? 'text' : 'not-allowed',
                borderColor: isEditable ? '#ced4da' : '#e0e0e0',
                color: isEditable ? '#000' : '#555',
                padding: '4px 8px',
              },
            }}
          />
        );
      },
    },
    {
      accessorKey: 'per_unit',
      header: 'Price unit',
    },
    {
      accessorKey: 'uom',
      header: 'UOM',
    },
    {
      accessorKey: 'last_change_price_date',
      header: 'Last price change',
    },
  ];

  const columns = useMemo(() => plantsColumns, [plants]);

  return (
    <MantineTable
      columns={columns}
      initialData={plants}
      enableRowSelection={false}
      loading={loading}
      showSelectedToggle={false}
      hideSelectColumn={true}
      showResetAll={false}
      pageSize={10}
      enableColumnFilter={false}
      enableFilters={false}
      enableExport={false}
      columnFilterDisplayMode={false}
    />
  );
};

export default StockPriceTable;
